import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/i18n/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Program from '@/pages/Program';
import Application from '@/pages/Application';
import About from '@/pages/About';
import Schedule from '@/pages/Schedule';
import Privacy from '@/pages/Privacy';
import Tuition from '@/pages/Tuition';
import FAQ from '@/pages/FAQ';
import ChatWidget from '@/components/ChatWidget';

function App() {
  return (
    <div className="App min-h-screen bg-white flex flex-col">
      <LanguageProvider>
        <BrowserRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/program" element={<Program />} />
              <Route path="/tuition" element={<Tuition />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/application" element={<Application />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
